import { UserManager } from 'oidc-client-ts';
import { logger } from '../utils/logger';
import eventBus from './globalEventBus';
import { getUserManagerSettings } from './oidcSettings';

const notifySignedOut = () => {
  eventBus.publish('UserSignedOut');
};

const setupUserManagerEvents = userManager => {
  userManager.events.addUserLoaded(user => {
    if (user) {
      logger.debug('OIDC User Loaded Access_token: ', user.access_token);
    }
  });

  userManager.events.addUserUnloaded(() => {
    logger.debug('OIDC User Unloaded');
    notifySignedOut();
  });

  userManager.events.addUserSignedOut(() => {
    logger.debug('OIDC User Signed Out');
    notifySignedOut();
  });

  userManager.events.addUserSignedIn(() => {
    userManager
      .signinSilent()
      .then(user => {
        if (user) {
          logger.debug('Silent sign-in after cross-tab sign-in complete');
        }
      })
      .catch(err => logger.error('Silent sign-in failed', err));
  });

  userManager.events.addAccessTokenExpired(() => {
    logger.debug('AccessToken Expired');
    userManager
      .signinSilent()
      .then(user => {
        if (!user) return Promise.reject('Re-authentication required');
        return user;
      })
      .catch(notifySignedOut);
  });

  userManager.events.addSilentRenewError(error => {
    logger.error('Silent Renew Error', error);
  });
};

export const createUserManager = () => {
  const userManager = new UserManager(getUserManagerSettings());
  setupUserManagerEvents(userManager);
  return userManager;
};

let userManager = null;

export const getUserManager = () => {
  if (!userManager) {
    if (window.userManager) {
      userManager = window.userManager;
    } else {
      userManager = createUserManager();
      // Ensure we store the instance globally to prevent multiple instances
      window.userManager = userManager;
    }
  }
  return userManager;
};

window.getUserManager = getUserManager;
